import { API_BASE_URL } from "../../urls.api";

export const AVATAR_URL = `${API_BASE_URL}/users/me/avatar`;
